import React, { useEffect, useState } from 'react';
import { CreateTableNew as CreateTable, Button, GeneralMessage, useGeneralMessage } from "../../../../../common/APICommon";
import { useApprovalPolicy } from '../../shared/useApprovalPolicy';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import AmountThresholdModal from './AmountThresholdModal';
import { ApprovalModules } from '../../../../../utils/enums';
import { useAmountBasedThreshold } from '../../shared/useAmountBasedThreshold';
import { LoadingSpinner } from '../../../../../common/Loading';

function AmountThresholdTab() {
  const showModuleSelection = false; // temporary hide the module selection for future update
  const [selectedModule, setSelectedModule] = useState(ApprovalModules.SALARY_ADVANCE); // this is the default for now, might change when implemented in other module
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedThreshold, setSelectedThreshold] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  // const { thresholds, fetchThresholds, loading, saveThreshold } = useApprovalPolicy();
  const { thresholds, fetchThresholds, loading, saveThreshold } = useAmountBasedThreshold();
console.log({thresholds});
  // // ADDED: Message hook in the parent
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  useEffect(() => {
    fetchThresholds(selectedModule);
    setCurrentPage(1);
  }, [fetchThresholds, selectedModule]);

  const headers = ["Label", "Min Amount", "Max Amount", "Approvers", "Actions"];
  const accessors = ["label", "minAmount", "maxAmount", "approverCount", "actions"];

  const actions = [
    {
      name: "Edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: (item) => {
        setSelectedThreshold(item);
        setIsModalOpen(true);
      },
      visible: true,
    }
  ];

  // // ADDED: Parent-level save handler to manage the success message
  const handleSave = async (payload) => {
    const result = await saveThreshold(payload);
    if (result.success) {
      showGeneralMessage("Configuration saved successfully!", true);
      fetchThresholds(selectedModule);
    } else {
      const errorMsg = result.error?.response?.data?.message || "Failed to save configuration.";
      showGeneralMessage(errorMsg, false);
    }
    return result;
  };

  const renderCustomCell = (row, accessor) => {
    if (accessor === "minAmount" || accessor === "maxAmount") {
      return (
        <span>
          {Number(row[accessor]).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        </span>
      );
    }
    if (accessor === "approverCount") {
      return <span>{row.approvers?.length || 0} Parallel Approvers</span>;
    }
    return null;
  };

  return (
    <div className="p-2">
      <div className={showModuleSelection ? 'flex items-center mb-4 bg-white p-3 rounded-lg border border-gray-200 shadow-sm' : 'mb-4' }>

        {showModuleSelection && (
          <div className="flex items-center space-x-3">
            <label className="text-sm font-medium text-gray-600">Select Module:</label>
            <select
              value={selectedModule}
              onChange={(e) => setSelectedModule(e.target.value)}
              className="rounded border border-gray-300 bg-gray-50 p-2 text-sm outline-none transition-all focus:ring-2 focus:ring-blue-500"
            >
              {Object.values(ApprovalModules).map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
        )}

        <Button
          name="Add New Threshold"
          icon={<AddIcon />}
          onClick={() => { setSelectedThreshold(null); setIsModalOpen(true); }}
          className="flex items-center bg-blue-600 text-white shadow-md hover:bg-blue-700"
        />
      </div>

      <div className="rounded-lg border border-gray-200 bg-white shadow-sm">
        <CreateTable
          tableName="AmountThresholds"
          headers={headers}
          accessors={accessors}
          data={thresholds}
          actions={actions}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={thresholds?.length}
          loading={loading}
          customCellRenderer={renderCustomCell}
        />
      </div>

      <AmountThresholdModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        moduleName={selectedModule}
        selectedData={selectedThreshold}
        onSave={handleSave} // // MODIFIED: Passing handleSave instead of just Success callback
        loading={loading}
      />

			<LoadingSpinner loading={loading} />
      <GeneralMessage form={showMessage} message={message} isSuccess={isSuccess} />
    </div>
  );
}

export default AmountThresholdTab;